import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import GridAreaContainer from '@sprinx/react-mui-components/GridAreaContainer';
import AddToCart from '../ComProvider/AddToCart';
var useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  addToCart: {}
});

function ProductDetailAddToCartButton(_ref) {
  var AddToCartProps = _ref.AddToCartProps,
      pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = _objectWithoutProperties(_ref, ["AddToCartProps", "classes", "className", "product", "renderToGridArea"]);

  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/React.createElement(GridAreaContainer, _extends({
    className: clsx(classes.root, className),
    renderToGridArea: renderToGridArea
  }, rest), /*#__PURE__*/React.createElement(AddToCart, _extends({
    product: product
  }, AddToCartProps, {
    className: clsx(classes.addToCart, (AddToCartProps || {}).className)
  })));
}

ProductDetailAddToCartButton.propTypes = {
  AddToCartProps: PropTypes.shape({}),
  classes: PropTypes.shape({
    addToCart: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  product: PropTypes.shape({}).isRequired,
  renderToGridArea: PropTypes.string
};
ProductDetailAddToCartButton.defaultProps = {
  AddToCartProps: undefined,
  classes: undefined,
  className: undefined,
  renderToGridArea: 'addToCart'
};
export default ProductDetailAddToCartButton;